/**
=========================================================
* Soft UI Dashboard React - v4.0.1
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import React, { useState, useEffect } from 'react';

// react-router-dom components
import { useLocation, NavLink, Navigate } from "react-router-dom";

// prop-types is a library for typechecking of props.
import PropTypes from "prop-types";

// @mui material components
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import Link from "@mui/material/Link";
import Icon from "@mui/material/Icon";

// Soft UI Dashboard React components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftButton from "components/SoftButton";
// Soft UI Dashboard React examples
import SidenavCollapse from "examples/Sidenav/SidenavCollapse";
import SidenavCard from "examples/Sidenav/SidenavCard";

// Custom styles for the Sidenav
import SidenavRoot from "examples/Sidenav/SidenavRoot";
import sidenavLogoLabel from "examples/Sidenav/styles/sidenav";

// Soft UI Dashboard React context
import { useSoftUIController, setMiniSidenav } from "context";
import { fetchAuthSession, updateUserAttributes, signOut } from 'aws-amplify/auth';

function Sidenav({ color, brand, brandName, routes, ...rest }) {


  const [name, setname] = useState()
  const [email, setEmail] = useState()

  useEffect(() => {
    (async () => {
      try {
        await fetchAuthSession().then(data => {

          let img = data.tokens.idToken.payload.picture;
          setname(data.tokens.idToken.payload.name)
          setEmail(data.tokens.idToken.payload.email);
          if (data.tokens.idToken.payload.picture !== undefined && data.tokens.idToken.payload.picture !== null) {
            console.log("aqui")
            setFot(img + "?t=" + new Date().getTime())
          } else {
            console.log("aca")
            setFot("https://codeflex.com.co/assets/img/modificacion2.png")
          }
        });
      } catch (err) {
        console.log(err);
      }

    })();
  }, []);
  const [fot, setFot] = useState();


  const [controller, dispatch] = useSoftUIController();
  const { miniSidenav, transparentSidenav } = controller;
  const location = useLocation();
  const { pathname } = location;
  const collapseName = pathname.split("/").slice(1)[0];

  const closeSidenav = () => setMiniSidenav(dispatch, true);

  useEffect(() => {
    // A function that sets the mini state of the sidenav.
    function handleMiniSidenav() {
      setMiniSidenav(dispatch, window.innerWidth < 1200);
    }

    /** 
     The event listener that's calling the handleMiniSidenav function when resizing the window.
    */
    window.addEventListener("resize", handleMiniSidenav);

    // Call the handleMiniSidenav function to set the state with the initial value.
    handleMiniSidenav();

    // Remove event listener on cleanup
    return () => window.removeEventListener("resize", handleMiniSidenav);
  }, [dispatch, location]);

  // Render all the routes from the routes.js (All the visible items on the Sidenav)
  const renderRoutes = routes.map(({ type, name, icon, title, noCollapse, key, route, href }) => {
    let returnValue;

    if (type === "collapse") {
      returnValue = href ? (
        <Link
          href={href}
          key={key}
          target="_blank"
          rel="noreferrer"
          sx={{ textDecoration: "none" }}
        >
          <SidenavCollapse
            color={color}
            name={name}
            icon={icon}
            active={key === collapseName}
            noCollapse={noCollapse}
          />
        </Link>
      ) : (
        <NavLink to={route} key={key}>
          <SidenavCollapse
            color={color}
            key={key}
            name={name}
            icon={icon}
            active={key === collapseName}
            noCollapse={noCollapse}
          />
        </NavLink>
      );
    } else if (type === "title") {
      returnValue = (
        <SoftTypography
          key={key}
          display="block"
          variant="caption"
          fontWeight="bold"
          textTransform="uppercase"
          opacity={0.6}
          pl={3}
          mt={2}
          mb={1}
          ml={1}
        >
          {title}
        </SoftTypography>
      );
    } else if (type === "divider") {
      returnValue = <Divider key={key} />;
    }

    return returnValue;
  });

  const handleUpgradeClick = () => {
    // Construir la nueva URL reemplazando el último segmento después del último '/' con 'upgrade'
    const currentUrl = window.location.href;
    const baseUrl = currentUrl.substring(0, currentUrl.lastIndexOf('/') + 1);
    const newUrl = baseUrl + 'upgrade';

    window.location.href = newUrl;
  };

  const formatName = (fullName) => {
    if (!fullName) {
      return '';
    }
    const nameParts = fullName.split(' ');
    const firstName = nameParts[0].toUpperCase();
    const secondName = nameParts[1] ? nameParts[1].toUpperCase() : '';
    return secondName ? `${firstName} ${secondName}` : firstName;
  };


  const formattedName = formatName(name);

  return (
    <SidenavRoot {...rest} variant="permanent" ownerState={{ transparentSidenav, miniSidenav }}>
      <SoftBox pt={3} pb={1} px={4} textAlign="center">
        <SoftBox
          display={{ xs: "block", xl: "none" }}
          position="absolute"
          top={0}
          right={0}
          p={1.625}
          onClick={closeSidenav}
          sx={{ cursor: "pointer" }}
        >
          <SoftTypography variant="h6" color="secondary">
            <Icon sx={{ fontWeight: "bold" }}>close</Icon>
          </SoftTypography>
        </SoftBox>
        <SoftBox component={NavLink} to="/" display="flex" alignItems="center">
          {brand && <SoftBox component="img" src={fot} alt="Soft UI Logo" width="2rem" />}
          <SoftBox
            width={!brandName && "100%"}
            sx={(theme) => sidenavLogoLabel(theme, { miniSidenav })}
          >
            <SoftTypography component="h6" variant="button" fontWeight="medium">
              {formattedName}
            </SoftTypography>
          </SoftBox>
        </SoftBox>

        <Divider />
          {email?.endsWith('@ecci.edu.co') ? (
            <img
              src="https://s3.amazonaws.com/www.codeflex.lat/documentos/72ce635f-3ff5-4db0-8a28-a5c9962c5fb0/logoECCI.png"
              style={{ width: '100%' }}
            />
          ) : email?.endsWith('@upmh.edu.mx') || email?.endsWith('@upmetropolitana.edu.mx') ? (
            <img
              src="https://s3.amazonaws.com/www.codeflex.lat/documentos/72ce635f-3ff5-4db0-8a28-a5c9962c5fb0/upmh.png"
              style={{ width: '100%' }}
            />
          ) : email?.endsWith('@usantoto.edu.co') || email?.endsWith('@usantotomas.edu.co') ? (
            <img
              src="https://s3.amazonaws.com/www.codeflex.lat/documentos/72ce635f-3ff5-4db0-8a28-a5c9962c5fb0/santoto.png"
              style={{ width: '100%' }}
            />
          ) : email?.endsWith('@uptc.edu.co') ? (
            <img
              src="https://s3.amazonaws.com/www.codeflex.lat/documentos/72ce635f-3ff5-4db0-8a28-a5c9962c5fb0/uptclogo.png"
              style={{ width: '100%' }}
            />
          ) : email?.endsWith('@est.una.ac.cr') || email?.endsWith('@una.ac.cr') ? (
            <img
              src="https://s3.amazonaws.com/www.codeflex.lat/documentos/e3d2b397-9806-4311-823c-89708f42b88e/UnaC.png"
              style={{ width: '100%' }}
            />
          ) : (
            <img
              src="https://s3.amazonaws.com/www.codeflex.lat/documentos/72ce635f-3ff5-4db0-8a28-a5c9962c5fb0/FAS/union.png"
              style={{ width: '100%' }}
            />
          )}
      </SoftBox>
      <Divider />
      <List>{renderRoutes}</List>

      <SoftBox pt={2} my={2} mx={2} mt="auto">
        {/*<SidenavCard />*/}
        <SoftBox mt={2}>
          <SoftButton
            component="a"
            onClick={handleUpgradeClick}
            rel="noreferrer"
            variant="gradient"
            color={color}
            fullWidth
          >
            Actualízate a PRO
          </SoftButton>
        </SoftBox>
      </SoftBox>
    </SidenavRoot>
  );
}

Sidenav.defaultProps = {
  color: "info",
  brand: "",
};

// Typechecking props for the Sidenav
Sidenav.propTypes = {
  color: PropTypes.oneOf(["primary", "secondary", "info", "success", "warning", "error", "dark"]),
  brand: PropTypes.string,
  brandName: PropTypes.string.isRequired,
  routes: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default Sidenav;
